import { IOverlayProps } from '@blueprintjs/core';
import React from 'react';
import ContentOverlay from '../../../components/ContentOverlay';
import ErrorCard from '../../../components/ErrorCard';
import LoadingCard from '../../../components/LoadingCard';
import { useCategoryEditLazyQuery } from '../../../generated/graphql';
import CategoryForm from './CategoryForm';

interface ICategoryEditOverlayProps extends IOverlayProps {
  id: string;
}

const CategoryEditOverlay = ({ id, ...overlayProps }: ICategoryEditOverlayProps) => {
  const [loadCategory, { data, called, loading, error: loadError }] = useCategoryEditLazyQuery({
    variables: {
      id,
    },
  });

  if (overlayProps.isOpen && !loading && !called) {
    loadCategory();
  }

  const renderContent = () => {
    if (loading) return <LoadingCard />;
    if (loadError || !data?.category) return <ErrorCard />;
    return (
      <CategoryForm
        onCancel={() => overlayProps.onClose?.()}
        onUpdated={() => {
          loadCategory();
          overlayProps.onClose?.();
        }}
        initialValues={data.category}
      />
    );
  };

  return <ContentOverlay {...overlayProps}>{renderContent()}</ContentOverlay>;
};

export default CategoryEditOverlay;
